import { Component, OnInit } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'arpio-center-panel',
  templateUrl: './arpio-center-panel.component.html',
  styleUrls: ['./arpio-center-panel.component.scss'],
  standalone: false,
})
export class ArpioCenterPanelComponent implements OnInit {
  isCustomComponent$ = this.uiService.isCustomComponent$

  constructor(private uiService: UiService) {}

  ngOnInit() {}
}
